var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column gap-4 p-2 text-center fs-14 grey-border br-8"},[_c('i',{staticClass:"el-icon-lock"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }